<template>
	<div id="uIDetails">
		<Breadcrumb>
			<BreadcrumbItem to="/userCenter/my">个人中心</BreadcrumbItem>
			<BreadcrumbItem>积分获取明细</BreadcrumbItem>
		</Breadcrumb>

		<div class="uIntegralTable">
			<p style="line-height: 40px;font-size: 24px;">积分获取明细</p>
			<Table :columns="uITableColumns" :data="uITableData" border>
				<template slot-scope="{ row }" slot="iType">
					<span v-if="row.type=='SP'">视频</span>
					<span v-else-if="row.type=='DB'">点播</span>
					<span v-else-if="row.type=='ZB'">直播</span>
					<span v-else-if="row.type=='ZSK'">知识库</span>
					<span v-else-if="row.type=='XXKT'">线下学堂</span>
				</template>
			</Table>
			<cpage :pageData="page" @clickPage="pageChange" style="margin-top: 20px;"></cpage>
		</div>
	</div>
</template>

<script>
	import {
		integralGet
	} from '../../request/api.js';
	import cpage from '../../components/content/page.vue'
	export default {
		components: {
			cpage
		},
		data() {
			return {
				memberId: '',
				uITableColumns: [{
					title: '获取时间',
					key: 'createTime',
					width: 200,
					className: 'uITableHeader'
				}, {
					title: '内容',
					key: 'remark',
					className: 'uITableHeader'
				}, {
					title: '类型',
					slot: 'iType',
					width: 120,
					align: 'center',
					className: 'uITableHeader'
				}, {
					title: '获得积分',
					key: 'integral',
					width: 100,
					align: 'center',
					className: 'uITableHeader'
				}],
				uITableData: [],
				page: {
					pageTotal: 0,
					pageSize: 10,
					pageNow: 0
				},
			}
		},
		methods: {
			// 分页
			pageChange(data) {
				this.page.pageNow = data - 1;
				this.getIntegralTableData()
			},
			getIntegralTableData() {
				let data = {
					memberId: this.memberId,
					page: this.page.pageNow,
					size: this.page.pageSize
				}
				integralGet(data).then(res => {
					this.uITableData = res.content;
					this.page.pageTotal = res.totalElements

				})
			}
		},
		mounted() {
			this.memberId = this.$store.state.userDetails.memberId;
			this.getIntegralTableData()
		}
	}
</script>

<style>
	.uIntegralTable {
		margin-top: 20px;
	}

	.uITableHeader {
		background-color: #f5f7f9 !important;
		color: #264653;
	}
</style>
